//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fetch from '@/axios/promise';
import {DORM, BASIC, JPT_URL} from "@/config/constant"
import {getFlowTypeList, getFlowInfoById, getExtFieldByExtTypeCode, saveFlowData, updateApprInfo, saveHiElement, getHiEleInfo} from '@/api/flow/flow';
import {getDicData, getInnerUserData} from '@/api/common/dic';
import promise from '@/axios/promise';

export default {
    data: function () {
        return {
            type: this.$route.query.type,
            /** 表单信息 **/
            mainId: this.$route.query.flowId,
            form: {
                id: this.$route.query.flowId
                // flowAttachments: []
            },
            extfieldConfig: [],//拓展字段配置信息
            childExtFieldConfig: [],//从表拓展字段配置信息
            tableData4: [],//从表数据

            /* 附件相关 */
            file_URL:'',
            fillList: [],
        }

    },
    created() {
        //通过id获取数据信息
        var flowId = this.form.id;
        var query = {flowId: flowId};
        this.getFlowInfoById(query);
        promise({
            url: DORM + "/expense/selectDictionType",
            method: "get",
            async: false,
            params: {
                type: "fileUrl"
            }
        }).then(res => {
            console.log(res[0].dicCode);
            this.file_URL = res[0].dicCode
        });
        this.$previewRefresh();
    },
    methods: {
        //获取当前用户
        getCurrUserInfo(){
            //获取当前用户
            fetch({
                url: BASIC + '/user/currUserInfo',
                method: 'GET',
            }).then(response => {
                this.currUserCode = response.username;
                this.currUserName = response.name;
            });
        },
        // 获取内部人员
        getInnerUserData(){
            var cond = {onJob:'是'};
            var condition = {'condition':JSON.stringify(cond)};
            getInnerUserData(condition).then(response => {
                // console.log(response);
                this.personOptions = response;
                this.personSourceData = response;
            });
        },
        //通过id获取流程信息
        getFlowInfoById(query){
            getFlowInfoById(query).then(response => {
                this.form = response.data;
                //根据流程类别渲染该流程下的拓展字段
                var flowTypeCode = this.form.flowTypeCode;
                var query = {
                    configType: "flow",
                    extTypeCode: flowTypeCode,
                    // enableState: "1"
                };
                this.getExtFieldByExtTypeCode(query);
                //渲染审批节点
                if (this.form.actElements != null && this.form.actElements != "" && this.form.actElements != undefined){
                    this.actEles = JSON.parse(this.form.actElements);
                }
                //获取附件信息
                if (response.data.flowAttachments != null) {
                    for (let i = 0; i < response.data.flowAttachments.length; i++) {
                        var file = {};
                        file.fileId = response.data.flowAttachments[i].fileId;
                        file.name = response.data.flowAttachments[i].attName;
                        file.fileUrl = response.data.flowAttachments[i].attPath;
                        file.contentCode = response.data.flowAttachments[i].contentCode;
                        this.fillList.push(file);
                    }
                }
                this.form.flowAttachments = [];
            });
        },
        //根据流程类别渲染该流程下的拓展字段
        getExtFieldByExtTypeCode(query) {
            getExtFieldByExtTypeCode(query).then(response => {
                var data = response.data;
                //取得扩展字段渲染表单
                var extfieldConfig = JSON.parse(data[0].extField);
                if (extfieldConfig.length != 0 && extfieldConfig != null && extfieldConfig != undefined){
                    //为每个组件赋值
                    var extFieldStr = this.form.extField;
                    if (extFieldStr != null && extFieldStr != "" && extFieldStr != undefined){
                        var extField = JSON.parse(extFieldStr);
                        for (var i = 0;i<extfieldConfig.length;i++){
                            var fieldCode = extfieldConfig[i].fieldCode;
                            var fieldType = extfieldConfig[i].fieldType;
                            var fieldRule = extfieldConfig[i].fieldRule.rule3;
                            for (var key in extField) {
                                if (key == fieldCode){
                                    if (((fieldType == 'dic' || fieldType == 'select') && fieldRule) || fieldType == 'checkbox'){
                                        var str = extField[key].join("，");
                                        extfieldConfig[i].defaultValue = str;
                                    }else{
                                        extfieldConfig[i].defaultValue = extField[key];
                                    }
                                }
                            }
                        }
                    }
                    this.extfieldConfig = extfieldConfig;
                }

                //取得子表拓展字段渲染子表
                if(data[0].childExtField != "" && data[0].childExtField != undefined && data[0].childExtField != null){
                  $('.childExtClass').show();
                  var childExtFieldConfig = JSON.parse(data[0].childExtField);
                  if (childExtFieldConfig != null && childExtFieldConfig != undefined && childExtFieldConfig.length != 0){
                      this.childExtFieldConfig = childExtFieldConfig;
                  }
                }else{
                  $('.childExtClass').hide();
                }
                //从表
                if (this.form.childExtField != null && this.form.childExtField != "" && this.form.childExtField != undefined){
                    this.tableData4 = JSON.parse(this.form.childExtField);
                    this.renderChildTabel(this.childExtFieldConfig, this.tableData4);
                }
            });
        },
        renderChildTabel(childExtFieldConfig,childExtField){
            debugger
            let html = "";
            for (var j = 0 ; j <childExtField.length;j++){
                html += `<slip-del ref="slipDel" del-text="删除" @slip-open="slipOpen" :key="j" @del-click="del(j)">`
                for (var i = 0 ; i<childExtFieldConfig.length;i++){//:key="i.infoFid"
                    html += `
                        <div style='height:auto;width:100%' class='LookCostDetail'>
                            <div class='costBottomBorder' style='padding-left:2%;text-align: left;'>
                                <mu-row class='didiCost borderBottomCCC'>
                                    <mu-col style='height: 0.45rem;padding-top:0.05rem;'>
                                        <span class='costNumb' style="font-weight:500">${childExtFieldConfig[i].fieldName}：</span>
                                        <span class='costNumb'>${childExtField[j][childExtFieldConfig[i].fieldCode]}</span>
                                        <div style='clear:both;'></div>
                                    </mu-col>
                                </mu-row>
                            </div>
                        </div>
                    `;
                }
                html += `</slip-del>`
            }
            $('#child_table').html(html)
        },
        //返回列表
        goback() {
            this.$router.go(-1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/view/flow/flowApplyDetail.vue